module.exports = __webpack_public_path__ + "img/style2.09235fc9.png";